import Skeleton from "react-loading-skeleton";

import styles from "../styles.module.scss";

export function Body() {
  return (
    <>
      {[...Array(8).keys()].map((item) => {
        return (
          <div className={styles.row} key={item}>
            <Skeleton
              count={7}
              height={"1.5rem"}
              className={styles.rowContainer}
            />
          </div>
        );
      })}
    </>
  );
}
